"use strict";
/**
 * Unless explicitly stated otherwise all files in this repository are licensed under the Apache-2.0 License.
 * This product includes software developed at Datadog (https://www.datadoghq.com/).
 * Copyright 2020-Present Datadog, Inc.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.AWSLambdaForwarderConfig = void 0;
/**
 * Log Autosubscription configuration for Datadog Forwarder Lambda functions. Automatically set up triggers for existing
 * and new logs for some services, ensuring no logs from new resources are missed and saving time spent on manual configuration.
 */
class AWSLambdaForwarderConfig {
    constructor() { }
    /**
     * @ignore
     */
    static getAttributeTypeMap() {
        return AWSLambdaForwarderConfig.attributeTypeMap;
    }
}
exports.AWSLambdaForwarderConfig = AWSLambdaForwarderConfig;
/**
 * @ignore
 */
AWSLambdaForwarderConfig.attributeTypeMap = {
    lambdas: {
        baseName: "lambdas",
        type: "Array<string>",
    },
    sources: {
        baseName: "sources",
        type: "Array<string>",
    },
    additionalProperties: {
        baseName: "additionalProperties",
        type: "any",
    },
};
//# sourceMappingURL=AWSLambdaForwarderConfig.js.map